import { Button, Modal } from 'flowbite-react';
import { get } from 'lodash';
import React, { useEffect, useState } from 'react';
import { RxCross2 } from 'react-icons/rx';
import { useMutation, useQueryClient } from 'react-query';
import { useToast } from 'src/context/ToastProvider';
import { useUserContext } from 'src/context/UserProvider';

const ShowLMSConfirmationModal = () => {
	const [showLmsConfirmationModal, setShowLmsConfirmationModal] = useState(false);

	const onClose = () => {
		localStorage.removeItem('lmsLevelupIntegrationMessage');
		setShowLmsConfirmationModal(false);
	};

	useEffect(() => {
		if (localStorage.getItem('lmsLevelupIntegrationMessage')) {
			setShowLmsConfirmationModal(true);
		}
	}, []);
	return (
		<div>
			<Modal position={'center'} dismissible={true} size={'md'} show={showLmsConfirmationModal} onClose={onClose}>
				<Modal.Body className="relative flex flex-col gap-y-8 justify-center rounded-[8px] border border-solid border-[#555770] dark:bg-[#1F2A37] p-8">
					<div>
						<h6 className="font-inter text-[20px] font-[600] leading-[120%]">LMS-Levelup Account Linking</h6>
						<p className="mt-[16px] font-inter text-[16px] font-[400] leading-[24px]">
							{localStorage.getItem('lmsLevelupIntegrationMessage')}
						</p>

						<div className="mt-[16px] flex items-center gap-[16px] justify-center">
							<Button
								color="purplePlaced"
								onClick={() => {
									onClose();
								}}
							>
								Close
							</Button>
						</div>
					</div>
					<RxCross2
						onClick={onClose}
						className="absolute right-[10px] top-[10px] h-[20px] w-[20px] cursor-pointer text-[#9CA3AF]"
					/>
				</Modal.Body>
			</Modal>
		</div>
	);
};

export default ShowLMSConfirmationModal;
